var headerMenu = {
    header: document.getElementById('header'),
    stickyClass: 'sticky',
    stickySmallClass: 'sticky-small',
    stickyBeforeClass: 'sticky-before',
    stickyHiddenClass: 'sticky-hidden',
    stickyBorderClass: 'sticky-border',
    stickyInitClass: 'sticky-init',
    menuOpenClass: 'menu-is-open',
    lastSt: 0, // ostatnia wartość scroll top
    mobileHeaderHeight: 90,
    desktopHeaderHeight: 130,
    //headerHeight: this.header.offsetHeight,
    init: function () {
        var self = this;
        if (self.header === null) return false;

        this.menuToggle();

        window.addEventListener('load', function () {
            // event scrolla dopiero podpinamy po załadowaniu wszystkich elementów
            window.addEventListener('scroll', self.scrollEvent);

            if (window.pageYOffset > self.stickyThreshold()) {
                addClass(self.header, self.stickyInitClass);
                addClass(self.header, self.stickyClass);
                addClass(self.header, self.stickyHiddenClass);
            }
        });

        //window.addEventListener('resize', self.scrollEvent);

        self.hh = this.header.offsetHeight;
    },
    isHomePage: function () {
        return hasClass(this.header, 'is-home');
    },
    stickyThreshold: function () {
        var threshold = 0;
        if (breakpoints.match(breakpoints.lg)) {
            threshold = 20;
        }

        return this.isHomePage() ? document.getElementById('rest-of-home-page').offsetTop - this.mobileHeaderHeight : threshold;
    },
    stickyHiddenThreshold: function () {
        return this.stickyThreshold() + 300;
    },
    stickySmallThreshold: function () {
        return this.stickyThreshold();
    },
    stickyBorderThreshold: function () {
        var threshold = this.isHomePage() ? 0 : 20;
        return this.stickySmallThreshold() + threshold;
    },
    scrollEvent: rafThrottle(function () {
        var self = this.headerMenu;
        var st = window.pageYOffset;
        
        if (st === self.lastSt) {
            //console.log('nothing change');
            return;
        }

        //console.log('st: ' + st);
        //console.log('lastSt: ' + self.lastSt);
        //console.log('stickyThreshold: ' + self.stickyThreshold()); //console.log('lastSt: ' + self.lastSt);
        //console.log('stickySmallThreshold: ' + self.stickySmallThreshold()); //console.log('lastSt: ' + self.lastSt);

        removeClass(self.header, self.stickyInitClass);

        if(self.isHomePage()) {
            if (st > self.stickyThreshold() - 120 && st < self.stickyThreshold() + 120) {
                addClass(self.header, self.stickyBeforeClass);
            } else {
                removeClass(self.header, self.stickyBeforeClass);
            }
        }

        if (st > self.stickyThreshold()) {
            addClass(self.header, self.stickyClass);
        } else {
            removeClass(self.header, self.stickyClass);
        }

        if (st > self.stickySmallThreshold()) {
            addClass(self.header, self.stickySmallClass);
        } else {
            removeClass(self.header, self.stickySmallClass)
        }

        if (st > self.stickyBorderThreshold()) {
            addClass(self.header, self.stickyBorderClass);
        } else {
            removeClass(self.header, self.stickyBorderClass)
        }

        if (st > self.stickyHiddenThreshold()) {
            var performOperation = true;

            // jeśli lastSt = 0 tzn że strona została dopiero załadowana, więc nie uktywamy menu, czekamy na interakcję
            if (self.lastSt === 0) {
                performOperation = false;
            }

            // jeśli menu jest otawrte to go nie ukrywamy
            if (hasClass(self.header, self.menuOpenClass)) {
                performOperation = false;
            }

            if (performOperation) {
                    if (st > self.lastSt) {
                        // scroll down
                        addClass(self.header, self.stickyHiddenClass);
                    } else {
                        // scroll up
                        removeClass(self.header, self.stickyHiddenClass);
                    }
            }
        } else {
            removeClass(self.header, self.stickyHiddenClass);
        }

        self.lastSt = st;
    }),

    menuToggle: function () {
        var self = this,
            menuToggle = document.getElementById('menu-toggle'),
            body = document.querySelector('body'),
            menuOpenClass = 'menu-is-open',
            isActiveClass = 'is-active',
            openedMenuClass = 'opened-menu';


        if (menuToggle === null) return;

        menuToggle.addEventListener('click', function () {
            if (hasClass(menuToggle, isActiveClass)) {
                closeMenu();
            } else {
                openMenu();
            }
        });

        function openMenu() {
            addClass(menuToggle, isActiveClass);
            addClass(self.header, menuOpenClass);
            addClass(body, openedMenuClass);
        }

        function closeMenu() {
            removeClass(menuToggle, isActiveClass);
            removeClass(self.header, menuOpenClass);
            removeClass(body, openedMenuClass);
        }
    }
};
